var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6756 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0711 1.92889 20 5.33333 20H14.6756C18.08 20 20 18.0711 20 14.6667V5.33333C20 1.92889 18.08 0 14.6756 0Z",
    fill: "#7A4BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36872 7.36899C4.91539 7.36899 4.54205 7.74232 4.54205 8.20454V15.0757C4.54205 15.529 4.91539 15.9023 5.36872 15.9023C5.83094 15.9023 6.20428 15.529 6.20428 15.0757V8.20454C6.20428 7.74232 5.83094 7.36899 5.36872 7.36899Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0354 4.08899C9.58207 4.08899 9.20874 4.46232 9.20874 4.92454V15.0757C9.20874 15.529 9.58207 15.9023 10.0354 15.9023C10.4976 15.9023 10.871 15.529 10.871 15.0757V4.92454C10.871 4.46232 10.4976 4.08899 10.0354 4.08899Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6399 10.9956C14.1777 10.9956 13.8044 11.369 13.8044 11.8312V15.0756C13.8044 15.529 14.1777 15.9023 14.631 15.9023C15.0933 15.9023 15.4666 15.529 15.4666 15.0756V11.8312C15.4666 11.369 15.0933 10.9956 14.6399 10.9956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.c6b9826be9544531fdd443f1eb0e6562.svg";
export { ForwardRef as ReactComponent };